/* eslint-disable eqeqeq */

import {
  Box,
  Button,
  Grid,
  GridItem,
  Heading,
  HStack,
  Icon,
  Text,
  Textarea
} from "@chakra-ui/react";
import React from "react";
import {
  BsFillChatLeftDotsFill,
  BsFillChatLeftTextFill,
  IoLocationSharp,
  IoPricetags,
  MdReviews
} from "react-icons/all";
import { Email } from "../modals/Appointment";
import { IBodyshopService } from "../UserService";
import { JobEstimationDetail } from "../modals/JobEstimationDetail";
import { NotifyService } from "../Services/NotifyService";

require("./feedback.css");
export interface feedbackProps {
  submitFeedback: (value: feedbackState) => void;
  ibsService: IBodyshopService;
  estimateDetails: JobEstimationDetail;
  navigateToScreen: (key: string) => void;
  showHideLoader: (value: boolean) => void;
  showFeedbackScreen: (value: boolean) => void;
}
export interface feedbackState {
  selectedType: string;
  description: string;
}
export class Feedback extends React.Component<feedbackProps, feedbackState> {
  notifyService = new NotifyService();
  constructor(props: feedbackProps) {
    super(props);
    this.state = {
      selectedType: "",
      description: ""
      // open: true
    };
  }

  private iBodyShopService = new IBodyshopService();

  renderFeedbackTypeButtons() {
    let buttons = [
      { name: "Pricing", icon: IoPricetags, key: "Pricing" },
      { name: "Location", icon: IoLocationSharp, key: "Location" },
      { name: "Replies", icon: BsFillChatLeftDotsFill, key: "Replies" },
      { name: "Reviews", icon: MdReviews, key: "Reviews" },
      { name: "Other", icon: BsFillChatLeftTextFill, key: "Other" }
    ];
    return (
      <>
        {buttons.map((e) => (
          <GridItem
            as={HStack}
            border={"1px solid"}
            borderColor={"blackAlpha.100"}
            rounded={2}
            p={[2, 4]}
            boxShadow={"sm"}
            background={
              this.state.selectedType === e.key ? "blue.400" : "white"
            }
            color={this.state.selectedType === e.key ? "white" : "blue.900"}
            onClick={() => this.setState({ selectedType: e.key })}
          >
            <Icon w={[5, 7]} h={[5, 7]} as={e.icon}></Icon>
            <Text fontWeight={"medium"} fontSize={"large"}>
              {e.name}
            </Text>
          </GridItem>
        ))}
      </>
    );
  }

  cancel() {
    this.props.showFeedbackScreen(false);
  }

  async sendEmails() {
    let templateId: string;
    switch (this.state.selectedType) {
      case "Pricing":
        templateId = "69e5f558-35cb-4b54-87a9-b171a4a2caac";
        break;
      case "Location":
        templateId = "69e5f558-35cb-4b54-87a9-b171a4a2caac";
        break;
      case "Replies":
        templateId = "69e5f558-35cb-4b54-87a9-b171a4a2caac";
        break;
      case "Reviews":
        templateId = "69e5f558-35cb-4b54-87a9-b171a4a2caac";
        break;
      case "Other":
        templateId = "69e5f558-35cb-4b54-87a9-b171a4a2caac";
        break;
    }
    const emailTemplates = await this.iBodyShopService.getEmailTemplates(
      this.props.estimateDetails.estimateId.toString()
    );

    const template = emailTemplates.find((template: any) => {
      return template.id === templateId;
    });

    if (template) {
      const emailTemplate: Email = {
        body: template.message,
        fromName: "Flow Autobody",
        subject:
          "Booking completed: " +
          this.props.estimateDetails.estimateNumber.toString(),
        to: [
          this.props.estimateDetails.email
            ? this.props.estimateDetails.email
            : "hello@flowautobody.au"
        ],
        assignedToId: this.props.estimateDetails.estimateId.toString(),
        jobNumber: this.props.estimateDetails.estimateNumber,
        bodyIsHtml: true,
        cc: ["hello@flowautobody.au"]
      };

      this.iBodyShopService
        .sendEmailWithTemplate(emailTemplate)
        .then((res: any) => {});
    } else {
      // add fallback email
      //   this.iBodyShopService
      //     .sendEmail(
      //       "Booking completed: " +
      //         this.props.estimateDetails.estimateNumber.toString(),
      //       this.props.estimateDetails.estimateId.toString(),
      //       this.props.estimateDetails.email
      //         ? this.props.estimateDetails.header.owner.contactDetails
      //             .emailAddress
      //     )
      //     .then((res: any) => {});
    }
  }

  submitFeedback() {
    // this.props.submitFeedback(this.state);
    let obj = {
      EstimateId: this.props.estimateDetails.estimateId,
      Factor: this.state.description,
      Remark: this.state.selectedType,
      JobNumber: this.props.estimateDetails.jobNumber
    };
    this.props.showHideLoader(true);
    this.props.ibsService.addEstimateFeedback(obj).then((res) => {
      if (res.ok) {
        res.json().then((resJSON) => {
          if (resJSON.IsSuccess) {
            this.sendEmails();
            this.notifyService.successNotitifcation(
              "Thank you! Your feedback means a lot to us"
            );
            this.props.submitFeedback(this.state);
            this.props.showFeedbackScreen(false);
          } else {
            this.notifyService.errorNotitifcation(
              "Sorry! Currently feedback system is down"
            );
          }
          this.props.showHideLoader(false);
        });
      } else {
      }
    });
  }
  render() {
    return (
      <div>
        <Heading as="h2" mb={4} color="blue.700" size="md">
          We’d love to hear your feedback!
        </Heading>

        <Box boxShadow={"md"} borderRadius="md" overflow={"hidden"} mt={6}>
          <Heading
            size="sm"
            p={4}
            color="white"
            w="100%"
            bg="blue.700"
            display={"flex"}
            justifyContent="space-between"
          >
            What factors made you decline the estimate?
          </Heading>
          <Grid templateColumns={"repeat(2, 1fr)"} gap={4} p={4}>
            {this.renderFeedbackTypeButtons()}
          </Grid>
        </Box>
        <Textarea
          marginTop={4}
          placeholder={"Let us know how we can improve our service..."}
          rows={4}
          value={this.state.description}
          onChange={(e) =>
            this.setState({ description: e.currentTarget.value })
          }
        />
        <Grid templateColumns={"repeat(2, 1fr)"} gap={4} marginTop={4}>
          <GridItem
            as={Button}
            size="lg"
            colorScheme="red"
            variant="outline"
            onClick={() => this.cancel()}
          >
            Cancel
          </GridItem>
          <GridItem
            as={Button}
            size="lg"
            colorScheme="blue"
            onClick={() => this.submitFeedback()}
          >
            Submit
          </GridItem>
        </Grid>
      </div>
    );
  }
}
